module.exports = __webpack_public_path__ + "img/icon-comments.e8ae644b.svg";